export default __webpack_public_path__ + "static/media/Java.57d8a778.png";